export const INFO_TEXTS = {
  brandName: "The brand name displayed across your application.",
  loyaltyTerm:
    "Term used for loyalty across online ordering, admin panel, and POS App.",
  taxIdTerm:
    "Label used for the store’s or customer business’s taxpayer identification number in order and invoice details.",
  taxTerm:
    "Term used for tax across all platforms (for example, “VAT” or “GST”).",
  contactInfo:
    "Contact display details shown in the footer of general emails not associated with a specific store.",
  symbolPlacement:
    "Choose whether the currency symbol appears before or after amounts.",
  showCurrencySymbol:
    "Choose whether to display the currency symbol alongside amounts across all platforms.",
  darkTheme: `Enable Dark Theme to customize the Navbar, Bottom Navbar and Footer.
    Select dark colors for each component to ensure a consistent dark theme.`,
  businessDetails: "Tenant's business details.",
  socialConfig:
    "Add your social media profile links. The corresponding icons will appear in email footers and online ordering website footers, linked to the URLs provided here.",
  androidStoreUrl: "The URL of the Android app in the Google Play Store.",
  iosStoreUrl: "The URL of the iOS app in the Apple App Store.",
  themeConfig: "These colors define your brand across the online ordering website and app.",
  linkConfig: "Used on the online ordering platform.",
};
